/** The KDF worker started from its bundle under the app's Trusted Types policy (part 25a; part 15, table T). */
import type { WorkerSource } from '../preview/platform.ts';
import type { KdfWorker } from './host.ts';

/** H1: a function starting a KDF worker (a module worker); each derivation starts its own. */
export function kdfWorker(source: WorkerSource<KdfWorker>): () => KdfWorker {
  return () => new source.Worker(source.trusted(source.url), { type: 'module', name: 'kdf' });
}
